import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
  config_info: null, // 网站基本信息,
  userInfo: null, // 用户信息
  logined: false, // 是否登录
  unread: 0,

  levelInfo: null, // 积分信息
  protectData: null, // 安全资料信息
  balance: {
    all: 0,
    data: null
  }, // 用户余额
  bankList: [], // 全部银行列表
  my_bankCard: [], // 绑定的银行列表
  user_withdraw: null, // 提现资金信息
  bill_group: [], // 记录分组数据
  lotteryMenu: null, // 彩种分类数据
  lotteryList: [], // 购彩大厅要显示的彩种
  groupLotteryList: [], // 购彩大厅要显示某种分类的彩种
  lottery_load: false, // 显示加载
  betArr: [], // 保存投注信息
  sixObj: {
    red: ['01', '02', '07', '08', '12', '13', '18', '19', '23', '24', '29', '30', '34', '35', '40', '45', '46'],
    blue: ['03', '04', '09', '10', '14', '15', '20', '25', '26', '31', '36', '37', '41', '42', '47', '48'],
    green: ['05', '06', '11', '16', '17', '21', '22', '27', '28', '32', '33', '38', '39', '43', '44', '49']
  },
  teObj: {
    red: ['3', '6', '9', '12', '15', '18', '21', '24'],
    blue: ['2', '5', '8', '11', '17', '20', '23', '26'],
    green: ['1', '4', '7', '10', '16', '19', '22', '25'],
    grey: ['0', '13', '14', '27']
  },
  tenObj: {
    onet: ['01'],
    twot: ['02'],
    threet: ['03'],
    fourt: ['04'],
    fivet: ['05'],
    sixt: ['06'],
    sevent: ['07'],
    eightt: ['08'],
    ninet: ['09'],
    tent: ['10']
  },

  service: null, // 客服网址
  allLotteryId: [], // 所有彩种的id
  creditInfo: null
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js